module.exports = __webpack_public_path__ + "img/V-L-4-unload-connect.f5cbf975.png";